import { Tooltip, type TooltipProps } from 'antd';
import { useRef, useState } from 'react';

export interface BaseEllipsisTextProps {
  title: string;
  placement?: TooltipProps['placement'];
}

/** scrollWidth 会取整，补测文字实际边界，避免漏掉不足 1px 的省略。 */
function isTruncated(node: HTMLSpanElement) {
  if (node.scrollWidth > node.clientWidth) return true;
  const width = node.getBoundingClientRect().width;
  if (!width) return false;
  const range = document.createRange();
  range.selectNodeContents(node);
  return range.getBoundingClientRect().width > width;
}

/** 触发提示时按实际宽度判断截断，避免逐项监听尺寸变化。 */
export default function BaseEllipsisText({
  title,
  placement = 'right',
}: BaseEllipsisTextProps) {
  const titleRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const changeOpen = (nextOpen: boolean) => {
    const node = titleRef.current;
    setOpen(Boolean(nextOpen && node && isTruncated(node)));
  };

  return (
    <Tooltip
      title={title}
      placement={placement}
      open={open}
      onOpenChange={changeOpen}
    >
      <span
        ref={titleRef}
        className="ellipsis-text block flex-auto min-w-0 overflow-hidden text-ellipsis whitespace-nowrap"
      >
        {title}
      </span>
    </Tooltip>
  );
}
